let sharePopup = function (el, intWidth, intHeight, blnResize) {

  // Set values for window
  intWidth = intWidth || '500';
  intHeight = intHeight || '400';
  var strResize = (blnResize ? 'yes' : 'no');

  // Set title and open popup with focus on it
  var strTitle = ((typeof el.getAttribute('title') !== 'undefined') ? el.getAttribute('title') : 'Social Share'),
    strParam = 'width=' + intWidth + ',height=' + intHeight + ',resizable=' + strResize;
  window.open(el.href, strTitle, strParam).focus();
};

if (document.querySelector('a.share')) {
  let social = document.querySelectorAll('a.share');
  for (let i = 0; i < social.length; i++) {
    social[i].addEventListener('click', function (e) {
      e.preventDefault();
      sharePopup(this);
    });
  }
}
